$(document).ready(function () {
    var cuttingItemType = null;
    if (window.location.href.indexOf("cutting_tools") > -1) {
        cuttingItemType = 'Tool';
    } else if (window.location.href.indexOf("cutting_types") > -1) {
        cuttingItemType = 'Type';
    } else if (window.location.href.indexOf("cutting_type_descriptions") > -1) {
        cuttingItemType = 'Type Description';
    }


    $(document).on('submit', '#tool-item-create-form', function (e) {
        e.preventDefault();
        addCuttingItem(cuttingItemType);
    });

    $('#tool-item-add-button').click(function (e) {
        e.preventDefault();
    });

    $('#tool-item-cancel-button').click(function (e) {
        e.preventDefault();
    });

    $('#editCuttingItemButton').click(function (e) {
        e.preventDefault();
    });

    if ($("#cutting_type-model-select").length >0) {
        toggleCuttingItemAddButton();
    }

    $(document).on("change", "#cutting_type-model-select", function () {
        toggleCuttingItemAddButton();
    });

    $('#cutting_type-model-select').on('change', function (e) {
        this.form.submit()
    });


});

function toggleCuttingItemAddButton() {
    var cuttingItemType = $('#cutting_type-model-select').val();
    if (cuttingItemType > 0) {
        $('#addCuttingItemButton').css('visibility', 'visible');
    } else {
        $('#addCuttingItemButton').css('visibility', 'hidden');
    }
}


function removeToolAddForm() {
    $('#newToolItem').html('');
}


function showToolAddForm(itemType) {

    myURL = null;
    switch (itemType) {
        case 'Tool':
            myURL = '/adm/cutting_tools/create';
            break;
        case 'Type':
            myURL = '/adm/cutting_types/create';
            break;
        case 'Type Description':
            myURL = '/adm/cutting_type_descriptions/create';
            break;
        default:
            break;
    }
    $('#newToolItem').html('').load(myURL, function () {
        let cuttingTypeText = $('#cutting_type-model-select option:selected').text();
        let cuttingTypeID = $('#cutting_type-model-select option:selected').val();
        $('#cutting_type_id').val(cuttingTypeID);
        $('#cutting-type-text').html(cuttingTypeText);
        turnOnTooltips();
    }).val();
}

function addCuttingItem(itemType) {
    myURL = null;
    switch (itemType) {
        case 'Tool':
            myURL = '/adm/cutting_tools';
            break;
        case 'Type':
            myURL = '/adm/cutting_types';
            break;
        case 'Type Description':
            myURL = '/adm/cutting_type_descriptions';
            break;
        default:
            break;
    }
    var myForm = $('#tool-item-create-form')[0];
    var myData = new FormData(myForm);
    var form = $(myForm);

    // myData.append('_method', 'PUT');
    $.ajax({
        type: 'POST',
        url: myURL,
        processData: false,
        contentType: false,
        cache: false,
        enctype: 'multipart/form-data',
        data: myData,
        async: false

    }).success(function (data) {
        if (!data.errors) {
            ppnotify('confirm', {
                title: 'Success',
                text: 'Record added. Add another?',
                type: data.type,
                confirmButtonText: 'Yes',
                cancelButtonText: 'No',
                closeOnConfirm: true,
                closeOnCancel: true,
                callback: function (isConfirm) {
                    if (isConfirm) {
                        appendNewToolItem(itemType, data);
                        // location.reload()

                    } else {
                        location.reload();
                    }
                }
            });

        } else {
            ppnotify('alert', {
                title: 'Error',
                message: data.msg,
                type: 'error',
            });

        }

    }).error(function (data) {
        ppnotify('alert', {
            title: 'Error',
            message: 'Invalid input or record already exists.',
            type: 'error',
        });
    });
}

function hideCuttingEditForm(id){
    $('#' + id + 'DD').css('display', 'none');
}

function editCuttingItem(id, itemType) {
    switch (itemType) {
        case 'Tool':
            var url = '/adm/cutting_tools/' + id + '/edit';
            break;
        case 'Type':
            var url = '/adm/cutting_types/' + id + '/edit';
            break;
        case 'Type Description':
            var url = '/adm/cutting_type_descriptions/' + id + '/edit';
            break;
    }
    $('#' + id + 'DD').css('display', 'table-row');
    $('#' + id + 'DDForm').html('').load(url, function () {
        turnOnTooltips();
    }).val();

}


function appendNewToolItem(itemType, data) {
    removeToolAddForm();
    showToolAddForm(itemType);
    switch (itemType) {
        case 'Tool':
            var cuttingType = $('#cutting_type-model-select option:selected').text();
            // build the new row and prepend it to the current page's table.
            myHtml = '<tr>';
            myHtml += '<td>' + data.size + '</td>';
            myHtml += '<td>' + (data.dec_eq_in * 1).toFixed(4) + '</td>';
            myHtml += '<td>' + (data.dec_eq_mm * 1).toFixed(4) + '</td>';
            myHtml += '<td>' + data.cutting_type + '</td>';
            myHtml += '<td>';
            myHtml += '<a title="Edit" onclick="editCuttingItem(' + data.id + ',\'' + itemType + '\')"><i class="fa fa-edit"></i></a>&nbsp;&nbsp;';
            // myHtml += '<a title="Delete" data-method="delete" data-confirm="Are you sure you want to delete this tool?" href="'+ getBaseUrl() +'adm/cutting_tools/' + data.id + '"><i class="fa fa-times"></i></a>';
            myHtml += '</td>';
            myHtml += '</tr><tr id="' + data.id + 'DD" style="display:none;"><td id="' + data.id + 'DDForm" colspan="5">';
            myHtml += ' </td></tr>';
            break;

        case 'Type':
            // build the new row and prepend it to the current page's table.
            myHtml = '<tr>';
            myHtml += '<td>' + data.name + '</td>';
            myHtml += '<td>'
            if (data.milling >0){
                myHtml += '<i class="fa fa-check">';
            }
            myHtml += '</td>';
            myHtml += '<td>'
            if (data.turning >0){
                myHtml += '<i class="fa fa-check">';
            }
            myHtml += '</td>';
            myHtml += '<td>';
            myHtml += '<a title="Edit" onclick="editCuttingItem(' + data.id + ',\'' + itemType + '\')"><i class="fa fa-edit"></i></a>&nbsp;&nbsp;';
            // myHtml += '<a title="Delete" data-method="delete" data-confirm="Are you sure you want to delete this tool?" href="'+ getBaseUrl() +'adm/cutting_tools/' + data.id + '"><i class="fa fa-times"></i></a>';
            myHtml += '</td>';
            myHtml += '</tr><tr id="' + data.id + 'DD" style="display:none;"><td id="' + data.id + 'DDForm" colspan="4">';
            myHtml += ' </td></tr>';
            break;
            break;

        case 'Type Description':
            var cuttingType = $('#cutting_type-model-select option:selected').text();
            // build the new row and prepend it to the current page's table.
            myHtml = '<tr>';
            myHtml += '<td>' + data.cutting_type + '</td>';
            myHtml += '<td>' + data.description + '</td>';
            myHtml += '<td>';
            myHtml += '<a title="Edit" onclick="editCuttingItem(' + data.id + ',\'' + itemType + '\')"><i class="fa fa-edit"></i></a>&nbsp;&nbsp;';
            // myHtml += '<a title="Delete" data-method="delete" data-confirm="Are you sure you want to delete this tool?" href="'+ getBaseUrl() +'adm/cutting_tools/' + data.id + '"><i class="fa fa-times"></i></a>';
            myHtml += '</td>';
            myHtml += '</tr><tr id="' + data.id + 'DD" style="display:none;"><td id="' + data.id + 'DDForm" colspan="3">';
            myHtml += ' </td></tr>';
            break;
    }

    $('#cuttingItem-list-table tbody').prepend(myHtml);
}

